var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-loading',{staticStyle:{"padding-top":"50%"},attrs:{"size":"24px","vertical":""}},[_vm._v(" 登录中... ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }